module.exports = __webpack_public_path__ + "img/06.7e550779.jpg";